import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/index';
import { EnvironmentFilled } from '@ant-design/icons';
import { useCustomData } from '../../pages/context/aboutCustomDataProvider';

interface locationDataInfo {
    left: string;
    top: string;
    addressInfo: string;
}

const AboutPart3: React.FC = () => {
    const themeColor = useSelector((state: RootState) => state.themeColor.value);
    const { customData } = useCustomData();
    const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
    const [locationList, setLocationList] = useState<locationDataInfo[]>([]);

    useEffect(() => {
        const mapPoints = customData
            .filter(item => item.description === 'mapPoint')
            .map(item => {
                const [position, name] = item.value.split('|');
                const [left, top] = position.split(',').map(val => val.trim());
                return {
                    left: `${left}px`,
                    top: `${top}px`,
                    addressInfo: name
                };
            });

        setLocationList(mapPoints);
    }, [customData]);

    const handleMouseEnter = (index: number) => {
        setHoveredIndex(index);
    };

    const handleMouseLeave = () => {
        setHoveredIndex(null);
    };

    return (
        <div className="about-part3">
            {locationList.map((location, index) => (
                <div
                    key={index}
                    className="internationnal"
                    style={{ left: location.left, top: location.top }}
                    onMouseEnter={() => handleMouseEnter(index)}
                    onMouseLeave={handleMouseLeave}
                >
                    <div className="internation"></div>
                    {hoveredIndex === index && (
                        <div className="address-info">
                            <EnvironmentFilled style={{ color: themeColor }} />
                            <div>{location.addressInfo}</div>
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

export default AboutPart3;
